export default __webpack_public_path__ + "static/media/dark-grey-activity.4ca90a7e.svg";